export function setDateTimeZone(date) {
    if (date) {
        date = new Date(new Date(date).toLocaleString("en-US", { timeZone: "America/New_York" }));
        return date;
    }
    else {
        return date;
    }
}